import {
  createTaxRegion as publicCreateTaxRegion,
  getTaxRegion as publicGetTaxRegion,
  updateTaxRegion as publicUpdateTaxRegion,
  deleteTaxRegion as publicDeleteTaxRegion,
  queryTaxRegions as publicQueryTaxRegions,
  typedQueryTaxRegions as publicTypedQueryTaxRegions,
} from './billing-v1-tax-region-tax-regions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  TaxRegionQuery,
  TaxRegionsQueryBuilder,
  typedQueryTaxRegions as universalTypedQueryTaxRegions,
} from './billing-v1-tax-region-tax-regions.universal.js';
import { onTaxRegionCreated as publicOnTaxRegionCreated } from './billing-v1-tax-region-tax-regions.public.js';
import { onTaxRegionDeleted as publicOnTaxRegionDeleted } from './billing-v1-tax-region-tax-regions.public.js';
import { onTaxRegionUpdated as publicOnTaxRegionUpdated } from './billing-v1-tax-region-tax-regions.public.js';

function customQueryTaxRegions(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryTaxRegions(httpClient)(),
    typedQueryFunction: (query: TaxRegionQuery) =>
      publicTypedQueryTaxRegions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): TaxRegionsQueryBuilder;
  function overloadedQuery(
    query: TaxRegionQuery
  ): ReturnType<typeof universalTypedQueryTaxRegions>;
  function overloadedQuery(query?: TaxRegionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createTaxRegion: MaybeContext<
  BuildRESTFunction<typeof publicCreateTaxRegion> & typeof publicCreateTaxRegion
> = /*#__PURE__*/ createRESTModule(publicCreateTaxRegion);
export const getTaxRegion: MaybeContext<
  BuildRESTFunction<typeof publicGetTaxRegion> & typeof publicGetTaxRegion
> = /*#__PURE__*/ createRESTModule(publicGetTaxRegion);
export const updateTaxRegion: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTaxRegion> & typeof publicUpdateTaxRegion
> = /*#__PURE__*/ createRESTModule(publicUpdateTaxRegion);
export const deleteTaxRegion: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTaxRegion> & typeof publicDeleteTaxRegion
> = /*#__PURE__*/ createRESTModule(publicDeleteTaxRegion);
export const queryTaxRegions: MaybeContext<
  BuildRESTFunction<typeof customQueryTaxRegions> & typeof customQueryTaxRegions
> = /*#__PURE__*/ createRESTModule(customQueryTaxRegions);
/** */
export const onTaxRegionCreated: BuildEventDefinition<
  typeof publicOnTaxRegionCreated
> &
  typeof publicOnTaxRegionCreated = createEventModule(publicOnTaxRegionCreated);
/**
 * Triggered when a tax region is deleted.
 */
export const onTaxRegionDeleted: BuildEventDefinition<
  typeof publicOnTaxRegionDeleted
> &
  typeof publicOnTaxRegionDeleted = createEventModule(publicOnTaxRegionDeleted);
/**
 * Triggered when a tax region is updated.
 */
export const onTaxRegionUpdated: BuildEventDefinition<
  typeof publicOnTaxRegionUpdated
> &
  typeof publicOnTaxRegionUpdated = createEventModule(publicOnTaxRegionUpdated);

export {
  SortOrder,
  WebhookIdentityType,
} from './billing-v1-tax-region-tax-regions.universal.js';
export {
  TaxRegion,
  CreateTaxRegionRequest,
  CreateTaxRegionResponse,
  ConflictErrorDetails,
  BulkCreateTaxRegionRequest,
  BulkCreateTaxRegionResponse,
  BulkCreateTaxRegionResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  GetTaxRegionRequest,
  GetTaxRegionResponse,
  UpdateTaxRegionRequest,
  UpdateTaxRegionResponse,
  DeleteTaxRegionRequest,
  DeleteTaxRegionResponse,
  QueryTaxRegionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryTaxRegionsResponse,
  CursorPagingMetadata,
  Cursors,
  CreateOrGetTaxRegionWithoutValidationRequest,
  CreateOrGetTaxRegionWithoutValidationResponse,
  DeleteTaxRegionWithoutDomainEventsRequest,
  DeleteTaxRegionWithoutDomainEventsResponse,
  BulkRestoreTaxRegionsRequest,
  BulkRestoreTaxRegionsResponse,
  BulkRestoreTaxRegionsResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountDetails,
  BaseEventMetadata,
  EventMetadata,
  TaxRegionCreatedEnvelope,
  TaxRegionDeletedEnvelope,
  TaxRegionUpdatedEnvelope,
  UpdateTaxRegion,
  TaxRegionsQueryResult,
  TaxRegionsQueryBuilder,
  TaxRegionQuerySpec,
} from './billing-v1-tax-region-tax-regions.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateTaxRegionApplicationErrors,
  UpdateTaxRegionApplicationErrors,
  CommonQueryWithEntityContext,
  TaxRegionQuery,
} from './billing-v1-tax-region-tax-regions.universal.js';
